/*
 * Engravity: quantity price breaks on product pages (helpers come from engravity-price-breaks.js).
 *  - The quantity picks the price break; picking a break moves the quantity into its range.
 *  - The price break dropdown is shown as a price chart for the selected color/size; tapping a row jumps to
 *    that break. The theme's dropdown stays underneath, hidden, and still drives the variant. If anything
 *    needed is missing, the dropdown is left as it was.
 *  - A line under the quantity shows the price each and the total.
 */
(function () {
  'use strict';

  var PB = window.EngravityPriceBreaks;
  if (!PB) return;

  var CSS = '' +
    '.egp-summary{margin:10px 0 0;font-size:13px;line-height:1.45}' +
    '.egp-summary strong{font-weight:600}' +
    '.egp-chart__title{display:block;margin-bottom:8px}' +
    '.egp-chart__list{border:1px solid var(--border-color,#e1e3e4);border-radius:6px;overflow:hidden;background:#fff}' +
    '.egp-chart__group{border-top:1px solid var(--border-color,#e1e3e4)}' +
    '.egp-row{display:grid;grid-template-columns:1.1fr 1fr 1fr;gap:8px;align-items:center;width:100%;margin:0;padding:9px 12px;' +
    'background:transparent;border:0;border-top:1px solid var(--border-color,#e1e3e4);font:inherit;font-size:14px;line-height:1.3;' +
    'text-align:left;color:inherit;cursor:pointer;-webkit-appearance:none;appearance:none}' +
    '.egp-chart__group .egp-row:first-child,.egp-row--head{border-top:0}' +
    '.egp-row--head{cursor:default;font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;opacity:.65;padding-top:7px;padding-bottom:7px}' +
    '.egp-chart__group .egp-row:hover{background:rgba(0,0,0,.03)}' +
    '.egp-row.is-active{background:rgba(31,70,86,.08);box-shadow:inset 3px 0 0 var(--accent-color,#1F4656);font-weight:600}' +
    '.egp-row:focus-visible{outline:2px solid var(--accent-color,#1F4656);outline-offset:-2px}' +
    '.egp-row[disabled]{cursor:default;opacity:.45}' +
    '.egp-save{color:#1a7f37;font-size:13px}' +
    '.egp-chart__note{margin:8px 0 0;font-size:13px;line-height:1.45;opacity:.8}' +
    '.egp-hidden{display:none !important}';

  function productJson() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent).product; } catch (e) { return null; }
  }

  function init() {
    var product = productJson();
    if (!product || !product.options || !product.variants) return;

    var tierPos = 0;
    product.options.forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      if (!tierPos && PB.TIER_OPTION.test(name)) tierPos = i + 1;
    });
    if (!tierPos) return;

    var values = [];
    product.variants.forEach(function (v) {
      var val = v['option' + tierPos];
      if (values.indexOf(val) === -1) values.push(val);
    });
    var tiers = PB.tiersFor(values);
    if (!tiers) return;

    var form = document.querySelector('form.product-form');
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    PB.injectCss('egp-product-style', CSS);

    function selectorFor(pos) {
      var sel = document.querySelector('select.product-form__single-selector[data-option-position="' + pos + '"]');
      if (sel) return { el: sel, get: function () { return sel.value; }, set: function (v) { sel.value = v; sel.dispatchEvent(new Event('change', { bubbles: true })); } };
      var radios = document.querySelectorAll('input.product-form__single-selector[data-option-position="' + pos + '"]');
      if (!radios.length) return null;
      return {
        el: radios[0],
        get: function () { var c = document.querySelector('input.product-form__single-selector[data-option-position="' + pos + '"]:checked'); return c ? c.value : null; },
        set: function (v) { Array.prototype.forEach.call(radios, function (r) { if (r.value === v && !r.checked) r.click(); }); }
      };
    }

    var tierSel = selectorFor(tierPos);
    if (!tierSel) return;
    var opt = tierSel.el.closest('.product-form__option');

    var summary = document.createElement('p');
    summary.className = 'egp-summary';
    var qtyItem = qtyInput.closest('.product-form__info-item') || qtyInput.parentNode;
    qtyItem.parentNode.insertBefore(summary, qtyItem.nextSibling);

    var others = [];
    for (var p = 1; p <= product.options.length; p++) if (p !== tierPos) others.push(p);

    // The variant for a price break at the color/size currently chosen.
    function variantAt(tierValue) {
      var chosen = others.map(function (pos) { var s = selectorFor(pos); return s ? s.get() : null; });
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = v['option' + tierPos] === tierValue;
        for (var j = 0; ok && j < others.length; j++) if (chosen[j] !== null && v['option' + others[j]] !== chosen[j]) ok = false;
        if (ok) return v;
      }
      return null;
    }

    var syncing = false;

    function currentQty() {
      var q = parseInt(String(qtyInput.value).replace(/[^\d]/g, ''), 10);
      return isNaN(q) ? 0 : q;
    }

    function setQty(q) {
      syncing = true;
      qtyInput.value = q;
      syncing = false;
    }

    function setTier(value) {
      if (tierSel.get() === value) return;
      syncing = true;
      tierSel.set(value);
      syncing = false;
    }

    // ---------- price chart ----------
    var chart = null, group = null;
    if (opt) {
      var sameLogo = tiers.some(function (t) { return /same\s*logo/i.test(t.value); });
      chart = document.createElement('div');
      chart.className = 'egp-chart';
      chart.innerHTML = '<span class="egp-chart__title text--strong">Quantity price breaks</span>' +
        '<div class="egp-chart__list"><div class="egp-row egp-row--head" aria-hidden="true"><span>Quantity</span><span>Price each</span><span>You save</span></div>' +
        '<div class="egp-chart__group" role="radiogroup" aria-label="Quantity price breaks"></div></div>' +
        '<p class="egp-chart__note">' + (sameLogo
          ? 'Prices are for one logo design. Ordering more than one logo? Add each logo to the cart separately.'
          : 'Price per item. Enter how many you need below and the matching price is applied automatically.') + '</p>';
      group = chart.querySelector('.egp-chart__group');
      tiers.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'egp-row';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-value', t.value);
        b.innerHTML = '<span>' + PB.rangeText(t) + '</span><span class="egp-price"></span><span class="egp-save"></span>';
        b.addEventListener('click', function () { tierSel.set(t.value); refresh(); });
        group.appendChild(b);
      });

      // Swap the dropdown (and its label and help line) for the chart; the dropdown keeps working underneath.
      var selectHost = tierSel.el.closest('.select-wrapper, .block-swatch-list, .color-swatch-list, .variant-swatch-list');
      if (selectHost) {
        selectHost.classList.add('egp-hidden');
        Array.prototype.forEach.call(opt.querySelectorAll('.product-form__option-name, .product-form__option-help'), function (el) { el.classList.add('egp-hidden'); });
      }
      opt.appendChild(chart);
    }

    function renderChart() {
      if (!group) return;
      var cur = tierSel.get(), base = null;
      Array.prototype.forEach.call(group.children, function (b) {
        var v = variantAt(b.getAttribute('data-value'));
        var price = v ? v.price : null;
        if (base === null && price !== null) base = price;
        var save = price !== null && base ? Math.round((1 - price / base) * 100) : 0;
        b.querySelector('.egp-price').textContent = price === null ? '—' : PB.money(price);
        b.querySelector('.egp-save').textContent = save > 0 ? 'Save ' + save + '%' : '';
        var on = b.getAttribute('data-value') === cur;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.disabled = !v;
      });
    }

    function renderSummary() {
      var q = currentQty();
      var t = PB.findTier(tiers, tierSel.get());
      var v = variantAt(tierSel.get());
      if (!q || !t || !v) { summary.textContent = ''; return; }
      summary.innerHTML = 'Price break <strong>' + PB.rangeText(t) + '</strong> &middot; ' + PB.money(v.price) + ' each &middot; <strong>' + PB.money(v.price * q) + ' total</strong> for ' + q;
    }

    function refresh() {
      renderSummary();
      renderChart();
    }

    // Quantity changed: pick the matching break. On a finished edit, lift a quantity below the lowest break.
    function onQty(finished) {
      if (syncing) return;
      var q = currentQty();
      if (!q) { if (finished) setQty(tiers[0].min); else { refresh(); return; } q = currentQty(); }
      if (finished && q < tiers[0].min) { setQty(tiers[0].min); q = tiers[0].min; }
      setTier(PB.tierForQty(tiers, q).value);
      refresh();
    }

    // Price break chosen: move the quantity into its range.
    function onTier() {
      if (syncing) return;
      var t = PB.findTier(tiers, tierSel.get());
      if (!t) return;
      var q = currentQty();
      if (q < t.min || q > t.max) setQty(t.min);
      refresh();
    }

    qtyInput.addEventListener('input', function () { onQty(false); });
    qtyInput.addEventListener('change', function () { onQty(true); });
    qtyInput.addEventListener('blur', function () { onQty(true); });
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]')) {
        setTimeout(function () { onQty(true); }, 0);
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.getAttribute && e.target.getAttribute('data-option-position') === String(tierPos)) onTier();
    }, true);
    document.addEventListener('variant:changed', function () { setTimeout(refresh, 0); });

    // Last check right before anything leaves the page (Add to cart, Buy it now).
    function beforeSubmit() { onQty(true); }
    form.addEventListener('submit', beforeSubmit, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.product-form__add-button, .shopify-payment-button')) beforeSubmit();
    }, true);

    onQty(true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();